import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			tbl_products:[],
			name:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);
		
	}

	handleShow(id, name){
		this.props.waiting.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'plasmatic_product/stock_by_lot/'+
			sessionStorage.getItem('health_facilities_id')+'/'+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		}).then(res => {
			this.props.waiting.handleClose();
	    	if(res.ok){
	          	return res.json();
	        }else{
	          	res.text().then(function(result) {
	            	swal('¡Error', result, 'error');
	          	});
        	}
        	
        }).then(response => {
			if(response !== undefined){
				this.setState({
					show:true,
					name:name,
					tbl_products: response
				});

			}

		})
	}

	getHealthFacilities(){
		//traer hospitales
		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({health_facilities:response});
			for (var i = 0; i < response.length; i++) {
				if(response[i].id === this.state.requested_to){
					this.setState({req_to:response[i].name});
				}
			}
		})
	}

	handleClose(){
		this.setState({
			show: false,
			requested_by:"",
			req_by:"",
			requested_to:"",
			req_to:"",
			observations:"",
			hour:"",
			date_form:"",
			user:"",
			tbl_products:[],
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Producto</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<span className="span-min">Producto: </span>
		        			<label>{this.state.name}</label>
		        		</div>
		        		<div className="col-xs-12">
		        			
		        			<Table responsive hover>
		        				<thead>
				                  	<tr>
					                    <th>Lote</th>
					                    <th>Fecha Entrada</th>
					                    <th>Cantidad</th>
					                    <th>Disponibles</th>
				                  	</tr>
				                </thead>
				                <tbody>
				                 	{this.state.tbl_products.map( (t, index) => (
				                    	<tr key={index}>
				                      		<td>{t.lot_number}</td>
						                    <td>{moment(t.entry_date).format('DD/MM/YYYY')}</td>
						                    <td>{t.cantidad}</td>
						                    <td>{t.disponibles}</td>
				                    	</tr>
				                  	))}
				                </tbody>
		        			</Table>

		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalDetails);